import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-threshold-indicator',
  imports: [],
  templateUrl: './threshold-indicator.component.html',
  standalone: true,
  styleUrls: ['./threshold-indicator.component.css'],
})
export class ThresholdIndicatorComponent {
  @Input() value: number = 0.0;
  @Input() type: 'FR' | 'FC' | 'STP' = 'FC';

  public isOutside(): boolean {
    if (!this.value || this.type === 'STP') return false;

    const max = this.type === 'FR' ? 22 : 100;
    const min = this.type === 'FR' ? 0 : 0;

    return this.value >= max || this.value <= min;
  }
}
